import React, { useEffect, useState } from "react";
import { buildApiUrl } from "../../config/api";
import axios from "axios";
import { Search, X } from "lucide-react";

const ModalRepresentantesConsult = ({
  clientesSeleccionados,
  onGuardar,
  onCerrar,
  token,
  numero,
  tipoDocumento,
}) => {
  const [clientes, setClientes] = useState(clientesSeleccionados);
  const [nuevoCliente, setNuevoCliente] = useState({
    nombre: "",
    ap_paterno: "",
    ap_materno: "",
    id_tipo_documento: "",
    numero: "",
    telefono: "",
    email: "",
  });
  
  useEffect(() => {
    if (clientesSeleccionados.length < 1) {
      verificarRepresentanteExistente();
    }
  }, []);

  const verificarRepresentanteExistente = async () => {
    try {
      if (!numero || !tipoDocumento) return;

      const response = await axios.get(
        buildApiUrl(
          `/api/clientes/representantes/verificar?numero=${numero}&tipoDocumento=${tipoDocumento}`
        ),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.existe) {
        const representantes = response.data.representantes || [];

        if (response.data.existe && response.data.representantes?.length > 0) {
          const nuevosRepresentante = [
            ...(nuevoCliente?.numero ? [nuevoCliente] : []),
            ...response.data.representantes.map((r) => ({
              nombre: r.nombre,
              ap_paterno: r.ap_paterno,
              ap_materno: r.ap_materno,
              id_tipo_documento: r.id_tipo_documento,
              numero: r.numero_documento,
              telefono: r.telefono || "",
              email: r.email || "",
              yaExiste: true,
            })),
          ];

          setClientes([...clientes, ...nuevosRepresentante]);
        }
      }
    } catch (error) {
      console.error("Error al verificar representante:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <span>Datos Representantes</span>
          <button className="close-btn" onClick={onCerrar}>
            ×
          </button>
        </div>
        <div className="modal-content">
          <div style={{ marginTop: "20px" }}>
            <table className="usuarios-table">
              <thead>
                <tr>
                  <th>Tipo de Documento</th>
                  <th>Numero</th>
                  <th>Nombre</th>
                  <th>Apellido Paterno</th>
                  <th>Apellido Materno</th>

                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {clientes.map((cliente, index) => (
                  <tr key={index}>
                    <td>{cliente.id_tipo_documento}</td>
                    <td>{cliente.numero}</td>
                    <td>{cliente.nombre}</td>
                    <td>{cliente.ap_paterno}</td>
                    <td>{cliente.ap_materno}</td>

                    <td>{cliente.email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button onClick={() => onGuardar(clientes)} className="save-btn">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalRepresentantesConsult;
